namespace Nobox.Nobox {
    export interface AccountListRequest extends Serenity.ListRequest {
        UserIds?: number[];
        IsAll?: number;
    }
}
